import { useEffect, useState } from 'react';
import { Money } from '@hesabat/finance-core';

/** منحنى خروج تكعيبى: سريع فى البداية ويهدأ عند الرقم الحقيقى. */
export function easeOutCubic(t: number): number {
  const clamped = Math.min(Math.max(t, 0), 1);
  return 1 - (1 - clamped) ** 3;
}

/**
 * قيمة وسيطة فى العدّ: المبلغ نفسه `Money` مضروبًا فى نسبة التقدم — النسبة وحدها رقم
 * عادى (زمن لا مال)، فلا يُحسب مبلغ بـ number. النهاية (`progress = 1`) هى القيمة بعينها.
 */
export function countUpFrame(target: string, progress: number): string {
  if (progress >= 1) return target;
  return Money.of(target).mul(easeOutCubic(progress).toFixed(4)).round(2).toString();
}

const DURATION_MS = 700;

/**
 * عدّاد أرقام اللوحة: يبدأ من صفر ويصل للقيمة الحقيقية فى ٧٠٠ms عند أول ظهور أو تغيّرها.
 * مع تقليل الحركة (أو بلا requestAnimationFrame) تظهر القيمة فورًا.
 */
export function useCountUp(target: string): string {
  const [shown, setShown] = useState(target);
  useEffect(() => {
    const reduced = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ?? true;
    if (reduced || typeof window.requestAnimationFrame !== 'function') {
      setShown(target);
      return;
    }
    let frame = 0;
    const start = performance.now();
    const tick = (now: number) => {
      const progress = (now - start) / DURATION_MS;
      setShown(countUpFrame(target, progress));
      if (progress < 1) frame = window.requestAnimationFrame(tick);
    };
    frame = window.requestAnimationFrame(tick);
    return () => window.cancelAnimationFrame(frame);
  }, [target]);
  return shown;
}
